export default "__VITE_ASSET__C70c8UaX__"